import identity from 'lodash/identity';
import { combineReducers } from 'redux';
import * as types from '../../actions/actionTypes';
import * as clearStore from './clearStore';
import * as estimateLoaded from './estimateLoaded';
import * as containerDeleted from './containerDeleted';
import * as closeEstimate from './closeEstimate';

const byIdActions = {
  [types.CLEAR_STORE]: clearStore.byId,
  [types.ESTIMATE_LOADED]: estimateLoaded.byId,
  [types.CONTAINER_DELETED]: containerDeleted.byId,
  [types.CLOSE_ESTIMATE]: closeEstimate.byId,
};

const allIdsActions = {
  [types.CLEAR_STORE]: clearStore.allIds,
  [types.ESTIMATE_LOADED]: estimateLoaded.allIds,
  [types.CONTAINER_DELETED]: containerDeleted.allIds,
  [types.CLOSE_ESTIMATE]: closeEstimate.allIds,
};

const byId = (state = {}, action) => {
  const act = byIdActions[action.type] || identity;
  return act(state, action);
};

const allIds = (state = [], action) => {
  const act = allIdsActions[action.type] || identity;
  return act(state, action);
};

const containersReducer = combineReducers({
  byId,
  allIds,
});

export default containersReducer;
